export default __webpack_public_path__ + "static/media/javascript-logo.9bd0f1d2.svg";